module.exports = __webpack_public_path__ + "img/reporting.13ec1324.png";